<div class="justify-content-center text-center align-content-center">
  <span class="w-100 mt-4 d-flex align-items-center">
    <hr class="text-secondary flex-grow-1 wing-line">
    <span class=" material-symbols-outlined text-secondary position-relative z-1 icon">{{icon()}}</span>
    <hr class="text-secondary flex-grow-1 wing-line">
  </span>
  <h3>{{emptyText()}}</h3>
  @if (buttonText()) {
    <button class="btn btn-outline-secondary m-auto mt-3 mb-4" (click)="btnClick.emit()">{{buttonText()}}</button>
  }
</div>
